<div [ngClass]="{ stickyContainer: mortgageCalculationService.showStickyMobileDisplay() }">
    <h2 id="{{ id }}_label" class="ap-margin-top-0 ap-margin-bottom-1">
        {{ 'main.mortgage-calculation.' + id + '.title' | apContent }}
    </h2>
    @if (storeService.isCalculatingMaxMortgage) {
        <ap-spinner
            [visuallyHiddenLabel]="true"
            class="ap-margin-bottom-1"
            loadingText="{{ 'mortgage-calculation.spinner.loading' | apContent }}"
            readyText="{{ 'mortgage-calculation.spinner.ready' | apContent }}"
            state="loading"
            [size]="'small'"
            [icon]="true"
        ></ap-spinner>
    } @else {
        <ap-amount-display
            [ngClass]="{ header: !mortgageCalculationService.showStickyMobileDisplay() }"
            id="{{ id }}_amount"
            [value]="mortgageDetails?.amount.amount"
            size="large"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            [emphasize]="true"
        >
        </ap-amount-display>
    }

    @if (showMonthlyAmounts) {
        <div class="ap-flex ap-flex-gap-2">
            <div id="{{ id }}_monthly_gross_label" class="ap-flex-basis-50">
                <h3 class="secondary ap-margin-bottom-0">
                    {{ 'mortgage-calculation.max-mortgage.monthly-gross.title' | apContent }}
                    <additional-info
                        id="{{ id }}_monthly_gross_hint"
                        class="text-primary"
                        [type]="hintType.ICON"
                        [key]="questionKeyGrossAmount"
                        titleKey="mortgage-calculation.max-mortgage.monthly-gross.additional-info.title"
                        contentKey="mortgage-calculation.max-mortgage.monthly-gross.additional-info.content"
                    >
                    </additional-info>
                    <ap-amount-display
                        id="{{ id }}_monthly_gross_amount"
                        [value]="mortgageDetails?.gross_monthly_amount?.amount"
                        size="medium"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="0"
                    >
                    </ap-amount-display>
                </h3>
            </div>
            <div id="{{ id }}_monthly_net_label" class="ap-flex-basis-50">
                <h3 class="secondary ap-margin-bottom-0">
                    {{ 'mortgage-calculation.max-mortgage.monthly-net.title' | apContent }}
                    <additional-info
                        id="{{ id }}_monthly_net_hint"
                        [type]="hintType.ICON"
                        [key]="questionKeyNetAmount"
                        titleKey="mortgage-calculation.max-mortgage.monthly-net.additional-info.title"
                        contentKey="mortgage-calculation.max-mortgage.monthly-net.additional-info.content"
                    >
                    </additional-info>
                    <ap-amount-display
                        id="{{ id }}_monthly_net_amount"
                        [value]="mortgageDetails?.net_monthly_amount.amount"
                        size="medium"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="0"
                    >
                    </ap-amount-display>
                </h3>
            </div>
        </div>
    }
</div>
